import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { SoundNames } from "sounds-enum";

export function ThemeSoundSetup(): void {
    const soundService = Services.get(SoundService);

    const musicVolume = 0.75;

    // soundService.registerPlay("ags_start_game", { id: (SoundNames as any).basegame_music, music: true, loop: true, volume: musicVolume });

    for (let i = 1; i <= 9; i++) {
        soundService.registerPlay(`meter_boost${i}`, { id: `meter_boost${Math.min(i, 5)}` });
    }

    soundService.registerPlay("coins_start", { id: (SoundNames as any).big_win_coins_loop, loop: true, volume: 0.6 });
    soundService.registerStop("end_coins", { id: (SoundNames as any).big_win_coins_loop });
    soundService.registerPlay("big_win_fireworks_start", { id: (SoundNames as any).big_win_fireworks, loop: true });
    soundService.registerStop("big_win_fireworks_end", { id: (SoundNames as any).big_win_fireworks });

    soundService.registerPlay("set_lines1", { id: (SoundNames as any).set_lines1 });
    soundService.registerPlay("set_lines2", { id: (SoundNames as any).set_lines2 });
    soundService.registerPlay("set_lines4", { id: (SoundNames as any).set_lines4 });
    soundService.registerPlay("set_lines5", { id: (SoundNames as any).set_lines5 });

    // soundService.registerPlay("reel_spin1", { id: (SoundNames as any).reel_spin1 });
    soundService.registerPlay("reel_spin_start", { id: (SoundNames as any).reel_spin3 });
    soundService.registerStop("reel_spin_stop", { id: (SoundNames as any).reel_spin3 });

    // bonus_{0}_land_reel_{1}
    soundService.registerPlay("bonus_X_land", { id: (SoundNames as any).wild_marker3 });

    soundService.registerPlay("bonus_Y_land", { id: (SoundNames as any).wild_marker2 });

    soundService.registerPlay("bonus_Z_land", { id: (SoundNames as any).wild_marker1 });

    soundService.registerPlay("multiplier_marker" , { id: (SoundNames as any).multiplier_marker });
}